
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useRevenueData = () => {
  const { data: revenueData = [], isLoading } = useQuery({
    queryKey: ["revenue-analytics"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("user_revenue")
        .select(`
          *,
          client:clients(name),
          job:jobs(title)
        `)
        .order("created_at", { ascending: true });
        
      if (error) {
        console.error("Error fetching revenue data:", error);
        throw error;
      }
      
      return data;
    },
  });

  return { revenueData, isLoading };
};
